<template>
  <div v-if="option.attribute.total>0" style="width: 100%;height: 100%">
    <t-pagination class="cpt-page" :total="option.attribute.total" :style="setStyles" :size="option.attribute.size"
      :page-size="option.attribute.pageSize" :current="option.attribute.current" @change="pageChange"
      :showPageNumber="true" :page-size-options="option.attribute.pageSizeOptions"
      :showJumper="option.attribute.autoSwitch" :showPageSize="option.attribute.autoSwitch_dropdown"
      :showPreviousAndNextBtn="true" :totalContent="option.attribute.autoSwitch_num" />
  </div>
</template>

<script setup>
import { getDataJson, pollingRefresh } from "@/utils/refresh-cpt-data";
import { reactive, getCurrentInstance, onMounted, ref, watch, computed } from "vue";
const instance = getCurrentInstance()
const props = defineProps({
  option: Object,
  show: Boolean,
  elementId: String,
  refMap: Object,
  components: Array, current: Object
})
let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
  if (val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
watch(() => props.option.attribute.hideCompInTabw,(val)=>{
  if (!val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
//uuid 必须
let uuid = require('uuid').v1();
let targetComponentId = ref(null) // 目标组件id
let cptData = reactive({ text: '' });//自定义组件值接收字段

const setStyles = computed(() => {
  return {
    '--textColor': props.option.attribute.textColor,
    '--textColorArrow': props.option.attribute.textColorArrow,
    '--backgroundColor': props.option.attribute.backgroundColor,
    '--backgroundColorCurrent': props.option.attribute.backgroundColorCurrent,
  }
})

//refreshCptData固定写法，必须！
const refreshCptData = () => {
  pollingRefresh(uuid, props.option.cptDataForm, loadData, props.components)
}

//自定义数据处理方法
const loadData = (cptDataForm, paras) => {
  getDataJson(props.option.cptDataForm, paras, (res) => {
    //res为数据表单的静态数据或执行API返回的数据
    cptData.text = res.value;
  })
}

const pageChange = (pageInfo) => {
  // console.log(pageInfo)
  props.option.attribute.current = pageInfo.current;
  props.option.attribute.pageSize = pageInfo.pageSize;
  console.log(props.refMap[targetComponentId.value], 'ajdnandujdnujdujasdnujdsujus')
  //分页处理
  instance.emit("clickHandler", props.option.interaction, 'default', props.cptData, pageInfo, 'cpt-page')
}
// 
const initEventData = () => {

  // 查找交互事件为 "setPages" 的事件对象
  let event = props.option.interaction.eventList.find(x => x?.intType === 'setPages')
  // 如果找不到该事件对象，则将属性 total 设置为 0 并返回
  if (!event) {
    props.option.attribute.total = 0
    return
  }
  // 将目标组件的 ID 设置为事件对象的 activePageId
  targetComponentId.value = event.activePageId
  // 获取目标组件对象
  let targetComponent = props.refMap[event.activePageId]

  // 如果找不到目标组件对象，则返回
  if (!targetComponent) {
    return
  }
  // 设置 其他属性
  let { current, pageSize } = props.option.attribute
  // 将属性 total 设置为目标组件的 tableData 属性的长度
  if (targetComponent.tableData) {
    props.option.attribute.total = targetComponent.tableData.length
  }
  // if (event.activePageKey === 'cpt-ninegrid') {
  //   props.option.attribute.autoSwitch_dropdown = false
  // }
  // 设置pageSize
  if (targetComponent.pageSize) {
    targetComponent.pageSize = pageSize
  }
  if (targetComponent.pageChange) {
    targetComponent.pageChange({ current, pageSize })
  }

}

// 初始化数据
const initPageData = (eventList) => {
  let eventIndex = eventList.findIndex(x => x?.intType === 'setPages')
  if (eventIndex === -1) {
    props.option.attribute.current = 1;
    props.option.attribute.pageSize = 5;
    props.option.attribute.total = 0
    props.option.attribute.pageSizeOptions = [5, 10, 20, 50].map(x => ({
      label: `${x} 条/页`,
      value: x
    }))
  }
}


onMounted(() => {
  //初始化数据，可选。echarts类组件需要放在onMounted中执行！
  if (dataReload.value.includes(0)) {
    refreshCptData();
  } 
  initEventData()
  console.log("props.option==========", props.option.attribute);


})

// 监听 refMap 中对应目标组件 ID 的值变化
watch(
  () => props.refMap[targetComponentId.value]?.tableData,
  (tableData) => {
    initEventData(props) // 根据table数据变化设置分页总数
  },
  { deep: true } // 如果 refMap 中的数据是深层次的对象或数组，需要开启深度监听
)
watch(
  () => props.option.interaction.eventList,
  (eventList) => {

    initPageData(eventList)
    // initEventData(props) // 根据table数据变化设置分页总数
  },
  { deep: true } // 如果 refMap 中的数据是深层次的对象或数组，需要开启深度监听
)


// onMounted(() => {
//   initEventData(props)
// })

//暴露refreshCptData，必须！
defineExpose({
  refreshCptData,
  initEventData
})
</script>

<style>
.cpt-page {
  color: var(--textColor) !important;
}


.cpt-page .t-pagination__number{
  background-color: var(--backgroundColor) !important;
}


.cpt-page .t-pagination__number.t-is-current{
  background-color: var(--backgroundColorCurrent) !important;
}

.cpt-page .t-pagination__total {
  color: var(--textColorArrow);
}

.cpt-page.t-pagination .t-pagination__btn{
  color: var(--textColorArrow) !important;
}

.cpt-page .t-input__inner {
  color: var(--textColorArrow);
}

.cpt-page .t-pagination__jump,
.cpt-page .t-input-adornment__text {
  color: var(--textColor);
  background-color: var(--backgroundColor) !important;
}

.cpt-page.t-pagination .t-input-number .t-input__inner {
  color: var(--textColor) !important;
}

</style>